<template>
  <nav class="navbar is-sticky is-codeasy has-shadow small-on-mobile" role="navigation">
    <div class="navbar-brand" style="margin-left: 9.33%">
      <a
        class="navbar-item is-hidden-mobile is-hidden-tablet-only"
        href="#home"
        v-scroll-to="'#home'"
      >
        <picture>
          <source :srcset="shortLogo.modernImageFormat" type="image/webp">
          <img :src="shortLogo.traditionalImageFormat" :alt="shortLogo.alt" height="28">
        </picture>
      </a>
      <mobile-nav class="is-hidden-desktop"></mobile-nav>
    </div>

    <div id="navMenu" class="navbar-menu" style="margin-right: 9.33%">
      <div class="navbar-end">
        <a class="navbar-item" href="#about" v-scroll-to="'#about'">
          <span class="is-family-secondary">About</span>
        </a>
        <a class="navbar-item" href="#services" v-scroll-to="'#services'">
          <span>Services</span>
        </a>
        <a class="navbar-item" href="#latest" v-scroll-to="'#latest'">
          <span>Latest Work</span>
        </a>
        <a class="navbar-item" href="#contact" v-scroll-to="'#contact'">
          <span >Contact</span>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import Vue from 'vue'
import MobileNavVue from '@/components/MobileNav.vue'

export default {
  name: 'Navbar',
  components: {
    'mobile-nav': MobileNavVue,
  },
  data () {
    return {
      shortLogo: {
        traditionalImageFormat: require('@/assets/logo-short.png'),
        modernImageFormat: require('@/assets/logo-short.webp'),
        alt: 'Codeasy logo',
      },
    }
  },
}
</script>

<style lang="scss" scoped>

// @import url("@/styles/bm-style.scss");

.navbar {
  height: 4rem;
  &.is-sticky {
    position: sticky;
    top: 0;
  }
  &.small-on-mobile {
    height: 56px;
  }
  .navbar-brand {
    height: 100%;
    a.navbar-item:hover {
      background-color: transparent;
      color: $codeasy-green;
    }
  }
  .navbar-end {
    .navbar-item {
      padding: 0 15px;
      span {
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
    }
    a.navbar-item:hover {
      background-color: transparent;
      color: $codeasy-green;
    }
  }
}

.is-full-height {
  height: 100%;
}
</style>
